import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Input,
	InputGroup,
	InputLeftAddon,
	InputRightElement,
} from '@chakra-ui/react';
import { useTagInput } from './tag-input.template.controller';

interface ITagInputProps {
	defaultValue: Record<string, string> | undefined;
	isLoading: boolean;
	onChange: (v: Record<string, string>) => void;
}

export default function TagInput(props: ITagInputProps) {
	console.info(props.defaultValue);
	const { t, tagForm, registerSubmitOnBlur, deleteTag, handleTagFormSubmit } = useTagInput(props);
	return (
		<FormControl mt="3" id="tags">
			<FormLabel>{t('Tags')}</FormLabel>

			{props.defaultValue
				? Object.keys(props.defaultValue as Object).map((key) => {
						return (
							<InputGroup key={key} mt={1} display="grid" gridTemplateColumns="1fr 2fr auto" size="sm">
								<InputLeftAddon
									title={key}
									maxW={40}
									overflow="hidden"
									whiteSpace="nowrap"
									textOverflow="ellipsis"
									children={key}
								/>
								<Input
									disabled={props.isLoading}
									{...registerSubmitOnBlur(key)}
									isDisabled={props.isLoading}
									placeholder={t('Write a tag here')}
								/>
								<InputRightElement width="4.5rem">
									<Button isLoading={props.isLoading} w="4rem" size="xs" onClick={() => deleteTag(key)}>
										{t('Delete')}
									</Button>
								</InputRightElement>
							</InputGroup>
						);
				  })
				: null}
			<Box as="form" mt={3} onSubmit={handleTagFormSubmit}>
				<InputGroup display="flex">
					<Input
						{...tagForm.register('tag')}
						name="tag"
						flex="4"
						isDisabled={props.isLoading}
						placeholder={t('Write a tag here')}
					/>
					<InputRightElement width="5rem">
						<Button
							w="4rem"
							size="xs"
							type="submit"
							colorScheme="primary"
							isLoading={props.isLoading}
							isDisabled={!tagForm.formState.isValid}
						>
							{t('Add')}
						</Button>
					</InputRightElement>
				</InputGroup>
			</Box>
		</FormControl>
	);
}
